// extracted by mini-css-extract-plugin
module.exports = {"journeyDetails":"styles-module--journeyDetails--1QTiI","pagePadding":"styles-module--pagePadding--HwIW8","list":"styles-module--list--Tsvr1"};